import { Link} from "react-scroll";

function Navbar() {
  return (
    <nav class="">
      <ul>
          <Link spy={true} smooth={true} offset={50} duration={1750} activeClass="active" class="navItem glass" to="about"><li>Bio</li></Link>
          <Link spy={true} smooth={true} offset={50} duration={1750} activeClass="active" class="navItem" to="projects"><li>Projets</li></Link>
          <Link spy={true} smooth={true} offset={50} duration={1750} activeClass="active" class="navItem" to="references"><li>References</li></Link>
          <Link spy={true} smooth={true} offset={50} duration={1750} activeClass="active" class="navItem" to="contacts"><li>Contacts</li></Link>
      </ul>
  </nav>
  );
}

export default Navbar;
